import React from 'react';
import Typography from '@material-ui/core/Typography';
import StatusFormatter from './StatusFormatter';
import UserInvitesActions from './UsersInvites/UsersInvitesActions';

export const statusFormatter = (cell, row) => <StatusFormatter isExpired={row.is_expired} />;

export const userFormatter = (cell, row) => (
  <>
    <Typography variant="subtitle1">
      {row.first_name} {row.last_name}
    </Typography>
    <Typography variant="body2" color="textSecondary">
      {row.email}
    </Typography>
  </>
);

export const inviteActionsFormatter = (cell, row) => <UserInvitesActions userInvite={row} />;

export default userFormatter;
